import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent } from '@progress/kendo-angular-grid';
import { v_DispatchEquipmentSvcdBus } from '../../../shared/models/v_DispatchEquipmentSvcdBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { FormGroup, FormControl } from '@angular/forms';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { EquipFieldData } from '@app/cp/shared/models/EquipFieldData';
import { EquipCustomFieldsComponent } from '../equip-custom-fields/equip-custom-fields.component';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { EquipmentService } from '@app/cp/shared/services/equipment.service';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { EquipmentPartBus } from '../../../shared/models/EquipmentPartBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'dispatch-equip-parts',
    templateUrl: './dispatch-equip-parts.component.html',
    styleUrls: ['./dispatch-equip-parts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchEquipPartsComponent extends BaseGridEditLineComponent<EquipmentPartBus, null, DispatchesService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, private svc_equip: EquipmentService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "EquipmentPartBus";
        this.appCode = "DispatchServicedEquipmentParts";
        this.appName = "Dispatch Serviced Equipment Parts";
    }
    active: boolean = false;
    hide() {
        this.active = false;
    }
    cancel(e: any) {
        this.hide();
    }
    show(data: EquipmentPartBus[]) {
        this.ListData = data;

        this.active = true;
    }
//    equipCustomData: EquipFieldData;
     all: boolean = false;
    cancelCustomFields() {
        this.ctrlOpenFlag = false;
    }
}
